module.exports = __webpack_public_path__ + "images/avatar4.svg";